import { IconButton } from '../icon-button'
import { Icon } from '../icon'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import {
  restartScenario,
  selectReferrerUrl,
  selectScenario,
  selectScenarioIsWaitingForAnswer,
  useDispatch,
} from '../../state'
import { clearScenarioCookie, getCookie } from '../../scenarios'
import { LoadingNewAnswer } from '../spinners/loading-new-answer'
import { ScenarioType } from '../../state/interfaces'
import { sendGA4Event } from '../../analytics/ga4'
import { getLocale } from '../../i18n/locale'

export const ScenarioCancel = () => {
  const dispatch = useDispatch()
  const referrerUrl = useSelector(selectReferrerUrl)
  const scenario = useSelector(selectScenario)
  const scenarioIsWaitingForAnswer = useSelector(selectScenarioIsWaitingForAnswer)

  const restart = useCallback(() => {
    dispatch(restartScenario())
  }, [dispatch])

  const redirectToWebsite = () => {
    clearScenarioCookie()

    if (
      scenario!.type === ScenarioType.EMAIL_PAGE_GO_INTERNET ||
      scenario!.type === ScenarioType.EMAIL_PAGE_GO_MOBILE
    ) {
      sendGA4Event('GA4_email_skip', {
        postal_code: getCookie('internetSearchPostalcode') || getCookie('geo-postal-code') || 'not set',
        region: getCookie('province') || 'not set',
        locale: getLocale(),
        provider_name: getCookie('providerName') || 'not set',
        misc: 'close',
      })
    }

    window.location.assign(referrerUrl as string)
  }

  const closeIcon = scenarioIsWaitingForAnswer ? (
    <LoadingNewAnswer />
  ) : (
    <IconButton label="Close" size="3xl" icon={<Icon icon="close" color="green.500" />} onClick={redirectToWebsite} />
  )
  const restartIcon = (
    <IconButton label="Restart" size="2xl" onClick={() => restart()} icon={<Icon icon="reload" color="green.500" />} />
  )

  return referrerUrl ? closeIcon : restartIcon
}
